// extracted by mini-css-extract-plugin
export default {"label_style":"antdPassInput_label_style__lyR-K","Pass_input":"antdPassInput_Pass_input__yayaV"};